import React from 'react'
import { useSelector } from 'react-redux';
import { getVisiblePrice, getVisibleSaveConfig } from '../../store/selectors/selectors';
import { PriceDetail } from '../Modals/PriceDetail/PriceDetail';
import { SaveConfigLink } from '../Modals/SaveConfigLink/SaveConfigLink';
import { WrapModals } from '../WrapModals/WrapModals';

export const CommonModalWindows = () => {

    const visiblePrice: any = useSelector(getVisiblePrice);
    const visibleSaveConfig: any = useSelector(getVisibleSaveConfig);



    return (
        <>
            {visiblePrice && <WrapModals>
                <PriceDetail />
            </WrapModals>}
            {visibleSaveConfig && <WrapModals>
                <SaveConfigLink />
            </WrapModals>}
        </>
    )
}
